export const memoryNotesKeys = {
    all: () => ['memoryNotes']
};
//# sourceMappingURL=memoryNotes.keys.js.map